// @/services/content/store/modules/sidebar.js
export class SidebarHandler {
  constructor(store) {
    this.store = store;
  }

  /**
   * Get Sidebar content by locale
   * @param {string} locale Locale to get content for
   * @returns {Object|null} Content or null if not found
   */
  getContent(locale = 'en') {
    // Try requested locale first
    const localeContent = this.store.state.data.sidebar?.[locale];
    if (localeContent) return localeContent;
    
    // Fall back to English if different locale was requested
    if (locale !== 'en') {
      return this.store.state.data.sidebar?.['en'] || null;
    }
    
    return null;
  }
}